<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <TaskForm
            @closedDialog="closeDialog"
            @callUpdateDropMenu="$emit('callUpdateDropMenu')"
            :read-only="readOnly"
            :facility-unchangeable="facilityUnchangeable"
            ref="taskForm" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import TaskForm from '@/modules/book/views/task/components/TaskForm.vue';

export default {
  name: 'AddTaskDialog',
  components: {TaskForm},
  props: {
    readOnly: Boolean,
    facilityUnchangeable: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.taskForm.cleanForm();
      this.$emit('closeDialog');
    },
    openDialog(item) {
      this.dialog = true
      if (!item) {
        return;
      }

      this.$refs.taskForm.setFormData(item);
    }
  }
}
</script>
<style lang="scss">
.form-dialog {
  background: rgb(255, 255, 255, 1);
}
</style>